export class Image {
  constructor(url: string, file?: File) {
    this.url = url;
    this.source = file;
  }

  id: string;
  readonly source: File;
  get title(): string {
    return this.source ? this.source.name : '';
  }
  readonly url: string;
}
